// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2-_MG","newExpiryDate":"styles_newExpiryDate__LbEVE","footer":"styles_footer__1EpJB"};